export type WorkspaceIdentity = string | number | undefined;

/**
 * Global bootstrap hooks use an empty workspace query as an explicit signal
 * that the request may run before a workspace has been selected. Treat that
 * sentinel as the same identity as the not-yet-selected workspace so the
 * successful bootstrap response is not mistaken for a stale workspace result.
 */
export function normalizeWorkspaceIdentity(
  workspaceId: WorkspaceIdentity | ""
): WorkspaceIdentity {
  return workspaceId === "" ? undefined : workspaceId;
}

export function isCurrentWorkspaceResponse(
  activeWorkspaceId: WorkspaceIdentity,
  requestWorkspaceId: WorkspaceIdentity
): boolean {
  return activeWorkspaceId === requestWorkspaceId;
}

export function isLatestWorkspaceRequest(
  activeWorkspaceId: WorkspaceIdentity,
  requestWorkspaceId: WorkspaceIdentity,
  activeGeneration: number,
  requestGeneration: number
): boolean {
  return (
    isCurrentWorkspaceResponse(activeWorkspaceId, requestWorkspaceId) &&
    activeGeneration === requestGeneration
  );
}
